export type Workers =
  | "autopilot"
  | "employee-engine"
  | "cal"
  | "images"
  | "brandfetch"
  | "huddle"
  | "self-driving"
  | "flags"
  | "atlas-v2"
  | "unsplash"
  | "iconfinder"
  | "teams-engine-v2"
  | "email-engine-v2"
  | "slack-engine-v2"
  | "twilio"
  | "poll-position"
  | "media"
  | "slack-admin"
  | "tremendous";

const getActualServiceUrl = (service: Workers): string => {
  switch (service) {
    case "poll-position":
      return "survey";
    default:
      return service;
  }
};

export function serviceURL(service: Workers): string {
  if (
    import.meta.env?.VITE_SERVICE_ENVIRONMENT === undefined ||
    import.meta.env?.VITE_SERVICE_ENVIRONMENT === "local"
  ) {
    return {
      autopilot: "http://localhost:9127",
      "employee-engine": "http://localhost:9001/",
      cal: "http://localhost:9008/",
      images: "http://localhost:9101/",
      brandfetch: "http://localhost:9108/",
      huddle: "http://localhost:9107/",
      "self-driving": "http://localhost:9109/",
      flags: "http://localhost:9110/",
      "atlas-v2": "http://localhost:9115/",
      unsplash: "http://localhost:9119/",
      iconfinder: "http://localhost:9126/",
      "teams-engine-v2": "http://localhost:9211/",
      "email-engine-v2": "http://localhost:9111/",
      "slack-engine-v2": "http://localhost:9212/",
      twilio: "http://localhost:9103/",
      "poll-position": "http://localhost:9128/",
      media: "http://localhost:9116/",
      "slack-admin": "http://localhost:9213/",
      tremendous: "http://localhost:9132/",
    }[service];
  }

  return `https://${getActualServiceUrl(service)}${import.meta.env?.VITE_SERVICE_ENVIRONMENT}.changeengine.com/`;
}
